import { List, P, Strong } from '@ahmdigital/ui';

import { ambulanceDisclaimerTasQld } from './shared';
import constants from '../../../ahm-constants';
import limitsRollover from './limits-rollover';

export default {
  intro: {
    accidentOverrideDescription: (
      <>
        <P>Basic hospital and extras for healthy singles and couples, includes:</P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>
            <Strong>Limited medically necessary ambulance^</Strong>
          </li>
        </List>
        <P>
          You also get a loyalty extras limit for <Strong>dental, physio, chiro and osteo</Strong> that goes up every
          year for 5 financial years, so totally worth sticking with us.
        </P>
      </>
    ),
    description: (
      <>
        <P>
          Basic hospital and extras for healthy singles and couples, includes <Strong>accident override</Strong> and{' '}
          <Strong>limited medically necessary ambulance^</Strong> just in case.
        </P>
        <P>
          You also get a loyalty extras limit for <Strong>dental, physio, chiro and osteo</Strong> that goes up every
          year for 5 financial years, so totally worth sticking with us.
        </P>
      </>
    ),
    disclaimer: ambulanceDisclaimerTasQld,
  },
  limitsRollover: {
    disclaimer: limitsRollover.disclaimer.flexiLimits,
    rollingOverLimitsText: limitsRollover.rollingOverLimitsText.flexiLimits,
  },
  upgrade: {
    cta: 'Check out essentials flexi basic plus',
    id: constants.PRODUCT.ESSENTIALS_FLEXI_BASIC_PLUS_EXCESS_750,
    title: 'Looking for more?',
  },
};
